import { makeApi } from "@zodios/core";
import { z } from "zod";

import { myvPlanningDtoSchema } from "@/types/backoffice/dto/myv/myv-planning-dto";

export const backofficeMyvApi = makeApi([
  {
    method: "put",
    path: "/programming/site/:id/refreshAllAppliances",
    response: z.any(),
    alias: "refreshAllMyVAppliances",
  },
  {
    method: "get",
    path: "/programming/site/:siteId/planning",
    response: z.array(myvPlanningDtoSchema),
    alias: "findSubscriberMyVPlanning",
  },
]);
